import React from 'react'
import UserGoalSettingContainer from '../../containers/goalsetting/UserGoalSettingContainer'


const GoalSettingPage = () => {
  return (
    <div>
      <UserGoalSettingContainer />
    </div>
  )
}

export default GoalSettingPage